import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import SpiritualLife from "./pages/Spiritual-Life";
import WorkLife from "./pages/Work-Life";
import EducationLife from "./pages/Education-Life";
import PersonalLife from "./pages/Personal-Life";
import { useEffect } from "react";
import PDFViewer from "./pages/PDFViewer";

export default function App() {
  const pathName = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathName]);
  return (
    <Routes>
      <Route path="" element={<Home />} />
      <Route path="spiritual-life" element={<SpiritualLife />} />
      <Route path="career" element={<WorkLife />} />
      <Route path="education" element={<EducationLife />} />
      <Route path="hobbies" element={<PersonalLife />} />
      <Route
        path="resume"
        element={<PDFViewer pdf_path="Caleb_Sipper_Resume.pdf" />}
      />
    </Routes>
  );
}
